import { render, staticRenderFns } from "./corrupted-rows.vue?vue&type=template&id=60466cbf&scoped=true"
import script from "./corrupted-rows.vue?vue&type=script&lang=js"
export * from "./corrupted-rows.vue?vue&type=script&lang=js"
import style0 from "./corrupted-rows.vue?vue&type=style&index=0&id=60466cbf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60466cbf",
  null
  
)

export default component.exports